import { useWslinkStore as wsLink } from "@/stores/ssaStore/wslink";
import { IParaviewLayersVisPayload, ParaviewViewState } from "@/types/dataset";
import { defineStore } from "pinia";
import { useActiveStore as active } from "./active";
import config from "../../../public/config.json";
const DEFAULT_VIEW_ID = config.paraview_defaults.defaultViewId;

export const useViewStore = defineStore("viewStore", {
	state: () =>
		({
			darkColor: [0.09, 0.09, 0.09],
			lightColor: [0.92, 0.92, 0.92],
			states: {},
			viewIds: [],
			paraviewViewState: null
		}) as {
			darkColor: number[];
			lightColor: number[];
			states: any;
			viewIds: any[];
			paraviewViewState: ParaviewViewState | null;
		},
	getters: {
		PARAVIEW_VIEW_STATE(): any {
			return this.paraviewViewState;
		},
		SSA_VIEW_IDS(): any[] {
			return wsLink().WSLINK_CONNECTED ? this.viewIds : [];
		},
		SSA_VIEW_STATES(): any {
			return this.states;
		},
		SSA_VIEW_ACTIVE_STATE(): any {
			const activeView = active().SSA_ACTIVE_VIEW;
			return this.states[activeView];
		}
	},
	actions: {
		SSA_VIEW_STATE_RESET() {
			this.states = {
				[DEFAULT_VIEW_ID]: {
					zScaling: 1,
					interaction: "3D",
					background: [0.09, 0.09, 0.09],
					foreground: [0.91, 0.91, 0.91],
					orientationAxesVisibility: 1,
					cameraParallelProjection: 0,
					centerAxesVisibility: 0,
					gridVisibility: 0,
					linked: 0,
					viewId: DEFAULT_VIEW_ID,
					type: "3D"
				}
			};
		},
		SSA_SET_PARAVIEW_VIEW_STATE(viewId: string, viewState: IParaviewLayersVisPayload) {
			if (this.paraviewViewState) this.paraviewViewState[viewId] = viewState;
		},
		SSA_VIEW_STATE_UPDATE(viewStates: any) {
			const newStates = Object.assign({}, this.states);
			for (let i = 0; i < viewStates.length; i++) {
				const { viewId } = viewStates[i];
				newStates[viewId] = viewStates[i];
			}
			this.states = newStates;
		},
		SSA_PARAVIEW_VIEW_DELETE_DATASET(currentViewId: string, paraviewLayerPath: string) {
			const newStates = Object.assign({}, this.paraviewViewState);
			if (!newStates[currentViewId]) newStates[currentViewId] = {};
			newStates[currentViewId][paraviewLayerPath] = [];
			this.paraviewViewState = newStates;
		},
		SSA_VIEW_IDS_SET(value: any) {
			this.viewIds = value;
		}
	},
	persist: false
});
